
/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Cars24ExpertLogo from "./images/cars24Expert.png";
import LazyImage from "../../shared/lazy-image";
import GreenTick from "./images/green-tick.svg";
import ImperfectionLogo from "./images/imperfection-logo.svg";
import ArrowIcon from "../../shared/arrow";
import Cars24Cover from "./images/cars24-cover.png";
import SevenDayReturn from "./images/seven-day-return.png";
import ThreeMonthsWarranty from "./images/three-months-warranty.png";
import NoImperfectionTick from "./images/no-imperfection-tick.svg";
import { NUMBER } from "../../../constants/app-constants";
import { appUrl } from "../../../constants/url-constants";

const BuyWithConfidenceCard = [
    {
        "text": "7-Day return & 100% refund",
        "hyperLink": null,
        "image": SevenDayReturn,
        "id": "x_days_return"
    },
    {
        "text": "3-Months Warranty",
        "hyperLink": `${appUrl()}/cars24cover/`,
        "image": ThreeMonthsWarranty,
        "id": "x_months_warranty"
    }
];

const sectionIcon = (imperfectionCount) => {
    return Number(imperfectionCount) ? ImperfectionLogo : NoImperfectionTick;
};
const QualityPromiseContent = ({onClick, inspectionReportData, plans = []}) => {
    const { report: { cards = [] } = {} } = inspectionReportData;
    // const imperfectionCount = (cards[0] || {}).title;
    const [imperfection = {}, perfectParts = {}] = cards || [];
    const {title: imperfectionCount, description} = imperfection || {};

    return (

        <div styleName={"styles.rightSectionWrap"}>
            <div styleName={"styles.topSectionWrapper"} >
                <div styleName={"styles.cars24Expert"}>
                    <img src={Cars24ExpertLogo} height={56} width={56}/>
                    <div>
                        <strong>CARS24 Expert</strong>
                        <p>Inspected by a CARS24 trained & qualified mechanic </p>
                    </div>

                </div>
                <div styleName="styles.buyWithConfidenceSection">
                    {BuyWithConfidenceCard.map(data => {
                        const {image, text} = data;
                        return (<div styleName="styles.buyWithConfidenceCard">
                            <LazyImage src={image} height={72} width={72} />
                            <p>{text}</p>
                        </div>);
                    })}
                </div>
            </div>

            <div styleName={"styles.imperfectionPanelButton"} onClick={() => onClick(cards[1])}>
                <div styleName={"styles.columnWrap"}>
                    <div styleName={"styles.leftCol"}>
                        <LazyImage width={18} height={18} src={GreenTick} />
                        <strong>{perfectParts.displayName || "Top-notch condition"}</strong>
                    </div>
                    <div styleName={"styles.rightColumn"}>
                        <ArrowIcon darkBlue={"DarkBlueArrow"} />
                    </div>
                </div>
                <p>Thoroughly tested and ready for the road as per CARS24 Quality Promise</p>
            </div>
            <div styleName={"styles.imperfectionPanelButton"} onClick={() => onClick(cards[0])}>
                <div styleName={"styles.columnWrap"}>
                    <div styleName={"styles.leftCol"}>
                        <LazyImage width={18} height={18} src={sectionIcon(imperfectionCount)} />
                        <strong>{imperfection.displayName || ""}</strong>
                        {Number(imperfectionCount) ? <span styleName={`styles.countValue styles.redBg`}>{Number(imperfectionCount)}</span> : null}
                    </div>
                    <div styleName={"styles.rightColumn"}>
                        <ArrowIcon darkBlue={"DarkBlueArrow"} />
                    </div>
                </div>
                <p>{description || ""}</p>
            </div>
            { plans.length > NUMBER.ZERO &&
            (
                <div styleName={"styles.cars24Cover"}>
                    <LazyImage styleName={"styles.cars24CoverImage"}  src={Cars24Cover} height={53} width={73} />
                    {plans.length >= NUMBER.FOUR && (<p>Extend your car’s warranty up to 3 years, add our optional CARS24 cover at checkout <span><a href={`${appUrl()}/cars24cover/`} target="_blank">Learn more.</a></span> </p>)}
                    {(plans.length >= NUMBER.ONE && plans.length <= NUMBER.THREE) && (<p>Extend your warranty with platinum cover <span><a href={`${appUrl()}/cars24cover/`} target="_blank">Learn more.</a></span> </p>)}
                </div>
            )
            }
        </div>
    );
};

QualityPromiseContent.propTypes = {
    onClick: PropTypes.func,
    inspectionReportData: PropTypes.object,
    plans: PropTypes.array
};

export default QualityPromiseContent;
